/* =========================================================
   Flexi Canap · Module en plus (bloc « FC · Module en plus »)
   Une seule écoute posée sur la page : le bouton marche aussi après un changement
   de couleur, quand la fiche est remplacée sans recharger la page (les scripts
   placés dans le bloc remplacé ne s'exécutent pas).
   La variante du module est lue au moment du clic (data-variante du bloc affiché) :
   elle correspond toujours à la couleur du canapé sélectionné.
   ========================================================= */
(function () {
  'use strict';
  if (window.FPModulePlus) return;
  window.FPModulePlus = true;

  // Module « @shopify/events » (même méthode que la fiche) pour que le panier latéral se mette à jour
  function evenements() {
    if (window.FP && typeof window.FP.evenements === 'function') return window.FP.evenements();
    return Promise.resolve(window.FPShopifyEvents || null);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-fp-plus-btn]') : null;
    if (!btn) return;
    var racine = btn.closest('[data-fp-plus]');
    if (!racine || btn.disabled) return;
    e.preventDefault();

    var err = racine.querySelector('[data-fp-plus-err]');
    var id = racine.getAttribute('data-variante');
    if (!id) return;
    btn.disabled = true;
    if (err) err.hidden = true;

    var sections = Array.prototype.map
      .call(document.querySelectorAll('cart-items-component[data-section-id]'), function (c) { return c.getAttribute('data-section-id'); })
      .join(',');
    var corps = { items: [{ id: Number(id), quantity: 1 }] };
    if (sections) corps.sections = sections;
    var Ev = null, diff = null;

    function echec(texte) {
      btn.disabled = false;
      if (err) { err.textContent = texte || 'Ajout impossible, réessayez.'; err.hidden = false; }
    }

    evenements()
      .then(function (m) { Ev = m && m.CartLinesUpdateEvent; })
      .catch(function () {})
      .then(function () {
        if (Ev) {
          try {
            diff = Ev.createPromise();
            racine.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: diff.promise }));
          } catch (x) { diff = null; }
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: JSON.stringify(corps)
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (rep) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (panier) {
            var erreur = !!rep.status;
            if (diff) {
              try {
                diff.resolve({ cart: Ev.createCartFromAjaxResponse(panier), detail: { items: panier.items, source: 'fp-module-plus', itemCount: 1, sections: rep.sections, didError: erreur } });
              } catch (x) {}
            }
            if (erreur) { echec(rep.description || rep.message); return; }
            btn.disabled = false;
            // Pastille du panier (écoutée par la fiche et l'en-tête)
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: panier } }));
            btn.classList.add('fp-ok');
            setTimeout(function () { btn.classList.remove('fp-ok'); }, 2500);
          });
      })
      .catch(function () {
        if (diff) { try { diff.reject(new Error('ajout')); } catch (x) {} }
        echec();
      });
  });
})();
